module.exports = __webpack_public_path__ + "img/icon-notice.a47ef947.png";